import { Grid, Typography, makeStyles, Theme } from '@material-ui/core';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';

const useStyles = makeStyles<Theme>((theme) => ({
  temperature: {
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '120%',
  },
  cloudCoverage: {
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '120%',
    letterSpacing: '0.15px',
  },
}));

const Weather = () => {
  const classes = useStyles();

  return (
    <Grid container item alignItems="center" justifyContent="space-between">
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <CloudQueueIcon />
        <Typography className={classes.temperature}>23°C</Typography>
      </div>
      <Typography className={classes.cloudCoverage}>Partially cloudy</Typography>
    </Grid>
  );
};

export default Weather;
